import { put, call, all, fork, takeEvery } from "redux-saga/effects";
import * as uploadDocumentActions from "../actionTypes/uploadDocumentActionTypes";
import * as uploadDocumentActionCreators from "../actionCreators/uploadDocumentActionCreators"
import { getInstitutionList, initiateUploadDocument, uploadDocuments, uploadDetails, resumeJourney } from "../services/APIservice";
import { ARGO_SUCCESS, AUTH_KEY, NOT_AUTHORIZED_ERROR } from "../../constants/constants";
import { getTransactionIdFromURL, getValueFromLocalStorage, replaceValueFromLocalStorage } from "../../constants/utils";

type IInstitutionListParams = { query: string, type: string }
function* getInstittutionListWorker({ query }: IInstitutionListParams) {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(uploadDocumentActionCreators.getInstitutionListRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getInstitutionList, query);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(uploadDocumentActionCreators.getInstitutionListSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(uploadDocumentActionCreators.getInstitutionListFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(uploadDocumentActionCreators.getInstitutionListFailure(error))
    }
  }
}


function* initiateUploadDocWorker({ request }: uploadDocumentActions.InititateUploadDocAction) {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(uploadDocumentActionCreators.initiateUploadDocRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(initiateUploadDocument, request);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(uploadDocumentActionCreators.initiateUploadDocSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(uploadDocumentActionCreators.initiateUploadDocFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(uploadDocumentActionCreators.initiateUploadDocFailure(error))
    }
  }
}


function* uploadDocumentWorker({ perfTxnId, documents }: uploadDocumentActions.UploadDocumentsAction) {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(uploadDocumentActionCreators.uploadDocumentRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(uploadDocuments, perfTxnId, documents);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(uploadDocumentActionCreators.uploadDocumentSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(uploadDocumentActionCreators.uploadDocumentFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(uploadDocumentActionCreators.uploadDocumentFailure(error))
    }
  }
}


function* uploadDetailsWorker({ request }: uploadDocumentActions.UploadDetailsAction) {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(uploadDocumentActionCreators.uploadDetailsRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(uploadDetails, request);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(uploadDocumentActionCreators.uploadDetailsSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(uploadDocumentActionCreators.uploadDetailsFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(uploadDocumentActionCreators.uploadDetailsFailure(error))
    }
  }
}


function* resumeJourneyWorker() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(uploadDocumentActionCreators.resumeJourneyRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(resumeJourney);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(uploadDocumentActionCreators.resumeJourneySuccess(true));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(uploadDocumentActionCreators.resumeJourneyFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(uploadDocumentActionCreators.resumeJourneyFailure(error))
    }
  }
}


function* watchOnFetchInstitutionList() {
  yield takeEvery(uploadDocumentActions.GET_INSTITUTION_LIST, getInstittutionListWorker)
}

function* watchOnInititateUploadDoc() {
  yield takeEvery(uploadDocumentActions.INITIATE_UPLOAD_DOC, initiateUploadDocWorker);
}

function* watchOnUploadDocuments() {
  yield takeEvery(uploadDocumentActions.UPLOAD_DOCUMENTS, uploadDocumentWorker)
}

function* watchOnUploadDetails() {
  yield takeEvery(uploadDocumentActions.UPLOAD_DETAILS, uploadDetailsWorker)
}

function* watchOnResumeJourney() {
  yield takeEvery(uploadDocumentActions.RESUME_JOURNEY, resumeJourneyWorker)
}

export default function* UploadDocumentSaga() {
  yield all([
    fork(watchOnFetchInstitutionList),
    fork(watchOnUploadDocuments),
    fork(watchOnInititateUploadDoc),
    fork(watchOnUploadDetails),
    fork(watchOnResumeJourney),
  ])
}
